import * as Yup from "yup";

const PatientContactInfoValidation = Yup.object().shape({
 phone: Yup.string().test(
  "phoneValidation",
  "Phone must contain 10 digits with the following format 000-000-0000",
  (value) => {
   if (!value) {
    return true;
   }
   return /\d{3}-\d{3}-\d{4}/.test(value);
  }
 ),
 email: Yup.string().email('Email must be a valid email').optional(),
 zipcode: Yup.string().test(
  "zipCodeValidation",
  "Zip code must be numbers and length must equal to 5",
  (value) => {
   if (!value) {
    return true;
   }
   return /^[0-9]{5}$/.test(value);
  }
 ),
});

export default PatientContactInfoValidation;
